import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'

import ChoiceButton from '@progyny/components/Buttons/ChoiceButton'
import {SetupProfileSubProps} from '@progyny/pages/SetUpProfile/types'
import {useMeStore} from '@progyny/store/meStore'

import {BirthAssignedSexes, UNSET} from '../../../const'

const BirthAssignedSex: React.FC<SetupProfileSubProps> = (props) => {
  const {
    navigator: Navigator,
    callback,
    onboardingData,
    persistMemberData,
  } = props

  const isInConservativeCountry = useMeStore((s) => s.isInConservativeCountry)
  const {t} = useTranslation()
  const choices = BirthAssignedSexes.filter(
    (item) =>
      item.value !== UNSET &&
      (!isInConservativeCountry() ||
        !['intersex', 'not-disclosed'].includes(item.value))
  )

  const handleChoiceClick = (choice: string) => {
    persistMemberData({birthAssignedSex: choice}, callback)
  }

  return (
    <>
      <Grid container justifyContent={'center'}>
        <Grid item xs={12}>
          <Box mt={3} width='100%'>
            {choices.map((item) => (
              <ChoiceButton
                data-role={'birth-assigned-sex-submit-button'}
                isSelected={onboardingData.birthAssignedSex === item.value}
                key={item.value}
                onClick={() => handleChoiceClick(item.value)}
              >
                {t(item.label!)}
              </ChoiceButton>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Box mt={5}>
        <Navigator
          submitDataRole={'birth-assigned-sex'}
          showBackButton={false}
        />
      </Box>
    </>
  )
}

export default BirthAssignedSex
